<div class="ap-token-selector-skeleton">
    <div class="ap-token-selector-skeleton__button-wrapper">
        @for (token of tokenTypes; track $index) {
            <ap-button-skeleton class="ap-token-selector-skeleton__button"></ap-button-skeleton>
        }
    </div>
    @if (hasRememberControl()) {
        <ap-paragraph-skeleton class="ap-token-selector-skeleton__paragraph" [rows]="1"></ap-paragraph-skeleton>
    }
</div>
